import {ReactNode} from 'react';

import {MessageDescriptor, useIntl} from 'react-intl';

import {view, tokens, createView} from '@sail/ui';

import {useTheme} from '../ThemeProvider';
import {AISparkle} from './AISparkle';

type Props = {
  title?: MessageDescriptor;
  height?: number | string;
  badge?: ReactNode;
  headerActions?: ReactNode;
  subHeader?: ReactNode;
};

export const AssistantHeader = createView(
  ({title, height = 52, badge, headerActions, subHeader, ...props}: Props) => {
    const intl = useIntl();
    const theme = useTheme();

    return (
      <view.header data-testid="assistant-header" {...props}>
        <view.div
          css={{
            stack: 'x',
            paddingX: 'medium',
            paddingY: 'small',
            borderBottom: '1px solid',
            borderBottomColor: 'border',
            alignY: 'center',
            distribute: 'space-between',
            zIndex: 2,
            height,
            background: `color-mix(in rgb, ${tokens.color.background.surface} 25%, transparent 75%)`,
            backdropFilter: 'blur(4px)',
          }}
        >
          <view.h1
            css={{
              font: 'heading.small',
              margin: 'space.0',
              stack: 'x',
              gap: 'small',
              alignY: 'center',
            }}
          >
            <AISparkle />
            {title ? intl.formatMessage(title) : theme.assistantHeaderTitle}
            {badge}
          </view.h1>

          <view.div css={{bleedRight: 'small', gap: 'xsmall'}}>
            {headerActions}
          </view.div>
        </view.div>

        {subHeader}
      </view.header>
    );
  },
);
